/**
 * 注册弹窗步骤指示器（五步）
 * - 圆点状态（已完成/当前/未到）+ 短标签 + 顶部进度条
 */
import type { RegisterStep } from '../../../../../stores/registerStore';
import { REGISTER_STEP_TOTAL, REGISTER_STEP_LABELS } from '../constants';

export function StepIndicator({ currentStep }: { currentStep: RegisterStep }) {
  return (
    <div className="px-6 py-4 flex-shrink-0 bg-slate-50">
      <div className="flex justify-between mb-2">
        {[1, 2, 3, 4, 5].map((step) => (
          <div key={step} className="flex flex-col items-center">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium mb-1 transition-all ${
              step < currentStep ? 'bg-teal-500 text-white' :
              step === currentStep ? 'bg-teal-600 text-white ring-4 ring-teal-100' :
              'bg-slate-200 text-slate-400'
            }`}>
              {step < currentStep ? '✓' : step}
            </div>
            <span className={`text-xs ${step <= currentStep ? 'text-teal-600' : 'text-slate-400'}`}>
              {REGISTER_STEP_LABELS[step as RegisterStep]}
            </span>
          </div>
        ))}
      </div>
      <div className="w-full h-1 bg-slate-100 rounded-full overflow-hidden">
        <div
          className="h-full bg-teal-500 transition-all duration-500 ease-in-out"
          style={{ width: `${((currentStep - 1) / (REGISTER_STEP_TOTAL - 1)) * 100}%` }}
        />
      </div>
    </div>
  );
}